import React from 'react';
import { ColumnDef, getCoreRowModel, getSortedRowModel, SortingState, useReactTable } from '@tanstack/react-table';
import { SimpleTableTW } from './components/SimpleTableTW';
import { SimpleSortTable } from './components/SimpleSortTable';

interface TableTWProps<T, V> {
  columns: ColumnDef<T, V>[];
  data: T[];
  isSorted?: boolean;
  // optional title to show on top of headers
  headerTitle?: string;
}

// This is the intended "entry point" for the new Tanstack Table DataTables.
// This way, the hooks are abstracted away from the developer.
// These are the "conventional" tables (should cover 80% of cases). A developer may write a more bespoke table in the future.
export function DataTableTW<T, V>({ isSorted, ...rest }: TableTWProps<T, V>) {
  if (isSorted) return <SortedTableTW {...rest} />;
  return <UnsortedTableTW {...rest} />;
}

function SortedTableTW<T, V>({ columns, data, ...rest }: TableTWProps<T, V>) {
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const table = useReactTable<T>({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });
  return <SimpleSortTable table={table} {...rest} />;
}

function UnsortedTableTW<T, V>({ columns, data, ...rest }: TableTWProps<T, V>) {
  const table = useReactTable<T>({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });
  return <SimpleTableTW table={table} {...rest} />;
}
